/**
 * This is the menu button configuration for the drilldown feature.
 */

const config = [
  {
    label: "Dismiss",
    icon: null,
    className: "btn btn-sm btn-link",
    attributes: {
      type: "reset",
      "data-dismiss": "modal",
      "data-event-category": "Drilldown",
      "data-event-action": "Close",
    },
  },
];

export { config as default };
